import React from 'react';
interface GoldDividerProps {
  symbol?: string;
  className?: string;
}
export function GoldDivider({
  symbol = '✦',
  className = ''
}: GoldDividerProps) {
  return <div className={`flex items-center justify-center w-full max-w-md mx-auto my-8 ${className}`} data-id="element-21">
      <div className="flex-grow h-px bg-gradient-to-r from-transparent via-gold to-transparent opacity-50" data-id="element-22"></div>
      <div className="mx-4 text-gold text-sm" data-id="element-23">{symbol}</div>
      <div className="flex-grow h-px bg-gradient-to-l from-transparent via-gold to-transparent opacity-50" data-id="element-24"></div>
    </div>;
}